import  shippingOptReducer from './shippingOptReducer';
export * from './shippingOptAction';
export default  shippingOptReducer;